<div class="alertDs__cont alertDs__cont--{{type}} alertDs__cont--{{size}} alertDs__cont--{{align}}">
  <div class="alertDs__cont__icon alertDs__cont__icon--{{align}}-{{size}}" *ngIf="icon">
    <app-ds-icon
      [icon]="icon"
      [color]="iconColor"
      [size]="alerProps?.IconSize">
    </app-ds-icon>
  </div>
  <div class="alertDs__cont__message">
    <app-ds-typography
      [text]="message"
      [color]="primaryTextColor"
      [fontFamily]="messageFontFamily"
      [size]="alerProps?.MessageSize">
    </app-ds-typography>
  </div>
</div>